import axios from 'axios';
import { API, getToken } from './adminApi';

/**
 * Resolve any image URL to a full URL.
 * If it starts with /uploads/ (backend-hosted), prefix the backend URL.
 * External http(s) URLs are returned as-is.
 */
export const resolveImage = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const backend = process.env.REACT_APP_BACKEND_URL || '';
  return `${backend}${url}`;
};

/**
 * Upload a File to backend and return the served URL (already resolved).
 */
export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const token = getToken();
  const { data } = await axios.post(`${API}/admin/upload`, fd, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return data.url; // stored as /uploads/xxx.jpg
};
